import React from 'react';

import { ColumnProps } from 'antd/lib/table';

import StyledTable from '@/components/tables/StyledTable';
import { useGetLpAccountIdentities } from '@/features/sso/api/getLpAccountIdentities';
import useAntdColumns from '@/hooks/useAntdColumns';

const LPAccountUserIdentitiesTable = () => {
  const columns: ColumnProps<any>[] = useAntdColumns({
    columnsKeys: ['provider', 'providerUserId', 'connection'],
  });

  const { data, isLoading } = useGetLpAccountIdentities();

  return (
    <StyledTable
      rowKey="id"
      columns={columns}
      dataSource={data || []}
      size="small"
      pagination={false}
      loading={isLoading}
    />
  );
};

export default LPAccountUserIdentitiesTable;
